module.exports = __webpack_public_path__ + "static/media/add.89c0536f.svg";